import { InputType } from "components/generators/inputsGenerator";
import { COMPETENCY_MAP_STATUS_OPTIONS, GRADE_OPTIONS, LANGUAGE_OPTIONS } from "constants/global";
import { Competency_Map_Status, CompetencyMapsQueryVariables, Grade, Language } from "@generated/graphql";
import VALIDATION from "helpers/validation";
import { FilterField } from "layout/TableConstructor/types";
import { IAutocompleteValue } from "components/inputs/Autocomplete/types";

export type CompetencyMapFilters = NonNullable<CompetencyMapsQueryVariables["filter"]>;

const filterFields: FilterField<CompetencyMapFilters>[] = [
  {
    name: "numericId",
    label: "ID",
    type: InputType.TEXT,
    rules: VALIDATION.inn,
    inputType: "number",
  },
  {
    name: "title",
    label: "Карта компетенций",
    type: InputType.TEXT,
    rules: VALIDATION.competencyMapTitle,
  },
  {
    name: "specialization",
    label: "Специализация",
    type: InputType.TEXT,
    rules: VALIDATION.competencyMapTitle,
  },
  {
    name: "grades",
    label: "Грейд",
    multiple: true,
    type: InputType.AUTOCOMPLETE,
    options: GRADE_OPTIONS,
    customFilter: (grades: { id: Grade; displayName: string }[]) => grades.map((grade) => grade.id),
    limitTags: 1,
  },
  {
    name: "competencesCount",
    label: "Количество компетенций",
    type: InputType.TEXT,
    rules: VALIDATION.inn,
    inputType: "number",
    isRange: true,
  },
  {
    name: "trialsCount",
    label: "Количество тестирований",
    type: InputType.TEXT,
    rules: VALIDATION.inn,
    inputType: "number",
    isRange: true,
  },
  {
    name: "createdAt",
    label: "Дата создания",
    type: InputType.DATE,
  },
  {
    name: "updateAt",
    label: "Дата изменения",
    type: InputType.DATE,
  },
  {
    name: "isRepositoryCheck",
    label: "Проверка репозитория",
    type: InputType.AUTOCOMPLETE,
    options: [
      { id: "true", displayName: "Да" },
      { id: "false", displayName: "Нет" },
    ],
    customFilter: (option: IAutocompleteValue) => option.id === "true",
  },
  {
    name: "lastTrialAt",
    label: "Дата последнего тестирования",
    type: InputType.DATE,
  },
  {
    name: "status",
    label: "Статус",
    type: InputType.AUTOCOMPLETE,
    options: COMPETENCY_MAP_STATUS_OPTIONS,
    customFilter: (value: { id: Competency_Map_Status; displayName: string }) => value.id,
  },
  {
    name: "language",
    label: "Язык",
    type: InputType.AUTOCOMPLETE,
    options: LANGUAGE_OPTIONS,
    customFilter: (value: { id: Language; displayName: string }) => value.id,
  },
];

export default filterFields;
